export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.4.1',
};
//# sourceMappingURL=buildEnv.js.map